import ApiService from './api.service'
import type { IntervenantData } from '@/types/services'

export interface FirmIntervenantResponse {
  id: number
  firmId: number
  name: string
  type: string
  email?: string
  phone?: string
  address?: string
}

export interface FirmIntervenantListResponse {
  data: FirmIntervenantResponse[]
}

/**
 * Service for managing firm-level intervenants
 */
class FirmIntervenantsService extends ApiService {
  constructor() {
    super({
      showNotifications: true,
      notificationOptions: {
        title: 'Firm Intervenants Error'
      }
    })
  }

  /**
   * Fetch all intervenants for the firm
   */
  async getFirmIntervenants(): Promise<FirmIntervenantListResponse | null> {
    return this.get('/api/firms/intervenants')
  }

  /**
   * Get a specific firm intervenant by ID
   */
  async getFirmIntervenantById(intervenantId: string): Promise<FirmIntervenantResponse | null> {
    return this.get(`/api/firms/intervenants/${intervenantId}`)
  }

  /**
   * Create a new firm intervenant
   */
  async createFirmIntervenant(intervenantData: IntervenantData): Promise<FirmIntervenantResponse | null> {
    return this.post('/api/firms/intervenants', intervenantData)
  }

  /**
   * Update an existing firm intervenant
   */
  async updateFirmIntervenant(
    intervenantId: string,
    intervenantData: IntervenantData
  ): Promise<FirmIntervenantResponse | null> {
    return this.put(`/api/firms/intervenants/${intervenantId}`, intervenantData)
  }

  /**
   * Delete a firm intervenant
   * Will fail if the intervenant is assigned to any project
   */
  async deleteFirmIntervenant(intervenantId: string): Promise<void | null> {
    return this.delete(`/api/firms/intervenants/${intervenantId}`)
  }
}

// Export an instance of the service
export default new FirmIntervenantsService()
